import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function OutdoorGrillIcon(props: IconProps) {
    return <Icon {...props} iconKey={"outdoor_grill"}/>
}
